import { createContext } from 'react';
import { SlideDirection, TOfficeSteps, TOfficeTutorial } from './Types';

export type TOfficeTutorialContext = {
  activeStep: [number, SlideDirection];
  tutorial: TOfficeTutorial | undefined;
  tutorialSteps: TOfficeSteps | undefined;
  onNextSlide: () => void;
  onPrevSlide: () => void;
  setTutorial: (tutorial: TOfficeTutorial) => void;
  onClose: () => void;
  openTutorial: (tutorialId: string) => void;
};

export const OfficeTutorialContext = createContext<TOfficeTutorialContext>({
  activeStep: [-1, SlideDirection.Initial],
  tutorial: undefined,
  tutorialSteps: undefined,
  onNextSlide: () => {},
  onPrevSlide: () => {},
  setTutorial: () => {},
  onClose: () => {},
  openTutorial: () => {},
});
